<template>
  <ts-card>
    <div class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative">
      <h4 class="ts-text-sm">{{ $t('leaveSubItem.pageTitle') }}</h4>
      <ts-modal-close-button />
    </div>
    <ts-card-wrapper>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group m-b-10">
            <label class="col-form-label">
              {{ $t('leaveSubItem.leaveType') }}
              <span class="text-danger">*</span>
              <i class="fa fa-spinner spin" v-if="fetch_before_create"></i>
            </label>
            <select
              v-model.number="model.leave_type_id"
              class="form-control"
              :class="{ 'is-invalid': errors.has('leave_type_id') }"
            >
              <option value>--{{ $t('select') }}--</option>
              <option v-for="(leaveType, index) in leaveTypes" :key="index" :value="leaveType.leave_type_id">{{
                leaveType.leave_type_en
              }}</option>
            </select>
            <div class="invalid-feedback" v-if="errors.has('leave_type_id')">{{ errors.first('leave_type_id') }}</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group m-b-10">
            <label class="col-form-label required">{{ $t('leaveSubItem.pageTitle') }}</label>
            <input
              v-model.trim="model.leave_sub_item"
              type="text"
              class="form-control"
              :class="{ 'is-invalid': errors.has('leave_sub_item') }"
            />
            <div class="invalid-feedback" v-if="errors.has('leave_sub_item')">{{ errors.first('leave_sub_item') }}</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group m-b-10">
            <label class="col-form-label required">{{ $t('leaveSubItem.maxDayAllow') }}</label>
            <input
              v-model.number="model.max_day_allow"
              type="number"
              class="form-control"
              :class="{ 'is-invalid': errors.has('max_day_allow') }"
            />
            <div class="invalid-feedback" v-if="errors.has('max_day_allow')">{{ errors.first('max_day_allow') }}</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group m-b-10">
            <label class="col-form-label required">{{ $t('leaveSubItem.maxRequestPerTime') }}</label>
            <input
              v-model.number="model.max_request_per_time"
              type="number"
              class="form-control"
              :class="{ 'is-invalid': errors.has('max_request_per_time') }"
            />
            <div class="invalid-feedback" v-if="errors.has('max_request_per_time')">
              {{ errors.first('max_request_per_time') }}
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group m-b-10">
            <label class="col-form-label required">{{ $t('leaveSubItem.allowFor') }}</label>
            <select v-model="model.allow_for" class="form-control" :class="{ 'is-invalid': errors.has('allow_for') }">
              <option value="">{{ $t('select') }}</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Both">Both</option>
            </select>
            <div class="invalid-feedback" v-if="errors.has('allow_for')">{{ errors.first('allow_for') }}</div>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-md-12 text-right">
          <ts-button class="mr-2" @click.prevent="$emit('close')">{{ $t('button.cancel') }}</ts-button>
          <ts-button class="btn-primary" :waiting="saving" @click.prevent="update" v-if="updating">
            {{ $t('button.update') }}
          </ts-button>
          <ts-button
            class="mr-2"
            outline
            color="primary"
            :waiting="saving_add_new"
            @click.prevent="saveAddNew"
            v-if="!updating"
          >
            {{ $t('button.saveAddNew') }}
          </ts-button>
          <ts-button class="btn-primary" :waiting="saving" @click.prevent="store" v-if="!updating">
            {{ $t('button.save') }}
          </ts-button>
        </div>
      </div>
    </ts-card-wrapper>
  </ts-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'formLeaveSubItem',
  props: ['editData'],
  data() {
    return {
      model: {
        leave_sub_item_id: 0,
        leave_type_id: '',
        leave_sub_item: '',
        max_day_allow: '',
        max_request_per_time: '',
        allow_for: ''
      },
      errors: new Errors(),
      saving: false,
      saving_add_new: false,
      updating: false,
      fetch_before_create: true
    }
  },
  created() {
    this.setEditData()
  },
  computed: {
    ...mapState('hr/leaveSubItem', ['leaveTypes'])
  },
  methods: {
    ...mapActions('hr/leaveSubItem', ['dataBeforeCreate']),
    saveAddNew() {
      this.errors = new Errors()
      this.saving_add_new = true
      this.$store
        .dispatch('hr/leaveSubItem/store', this.model)
        .then(response => {
          this.saving_add_new = false
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch(error => {
          this.saving_add_new = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    },
    store() {
      this.errors = new Errors()
      this.saving = true
      this.$store
        .dispatch('hr/leaveSubItem/store', this.model)
        .then(response => {
          this.saving = false
          this.$toasted.success(response.message)
          this.$emit('close')
          this.$emit('before-close')
        })
        .catch(error => {
          this.saving = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    },
    update() {
      this.errors = new Errors()
      this.saving = true
      this.$store
        .dispatch('hr/leaveSubItem/update', {
          id: this.editData.leave_sub_item_id,
          data: this.model
        })
        .then(response => {
          this.saving = false
          this.$toasted.success(response.message)
          this.$emit('close')
          this.$emit('before-close')
        })
        .catch(error => {
          this.saving = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    },
    async setEditData() {
      await this.dataBeforeCreate().finally(() => (this.fetch_before_create = false))
      if (!_.isEmpty(this.editData) || !this.editData === undefined) {
        this.updating = true
        this.model = {
          leave_sub_item_id: this.editData.leave_sub_item_id,
          leave_type_id: this.editData.leave_type_id,
          leave_sub_item: this.editData.leave_sub_item,
          max_day_allow: this.editData.max_day_allow,
          max_request_per_time: this.editData.max_request_per_time,
          allow_for: this.editData.allow_for
        }
      }
    },
    clearInput() {
      this.model = {
        leave_sub_item_id: 0,
        leave_type_id: '',
        leave_sub_item: '',
        max_day_allow: '',
        max_request_per_time: '',
        allow_for: ''
      }
    }
  }
}
</script>
